import React from 'react';

import * as Styled from './keyboard-shortcut.style';

export type KeyboardShortcutProps = {
  shortcut: string[];
};

export const KeyboardShortcut: React.FC<KeyboardShortcutProps> = ({
  shortcut,
}) => {
  return (
    <Styled.Container>
      {shortcut.map((key) => (
        <Styled.Key key={key}>{key}</Styled.Key>
      ))}
    </Styled.Container>
  );
};
